import React, { useMemo } from 'react';
import Select from "./Select.jsx";
import { useTranslation } from 'react-i18next';
import { setAppLocale } from '../../i18n';

/** EN | IT segmented pill — matches app-suite-rn LoginScreen langToggle. */
const LanguageSelect = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const activeLocale = i18n.language?.startsWith('it') ? 'it' : 'en';

  return (
    <div
      className={`login-lang-toggle ${className}`.trim()}
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        className={`login-lang-btn${activeLocale === 'en' ? ' login-lang-btn--active' : ''}`}
        onClick={() => setAppLocale('en')}
        aria-pressed={activeLocale === 'en'}
      >
        EN
      </button>
      <button
        type="button"
        className={`login-lang-btn${activeLocale === 'it' ? ' login-lang-btn--active' : ''}`}
        onClick={() => setAppLocale('it')}
        aria-pressed={activeLocale === 'it'}
      >
        IT
      </button>
    </div>
  );
};

export default LanguageSelect;
